import React from "react";
import { useRecoilState, useSetRecoilState } from "recoil";

import SidebarMarkSlider from '../../../sidebar/sliders/SidebarMarkSlider.jsx'

import {
  TRAVEL_TIMES,
  travelTimeLoadingAtom,
  travelTimeOptionsAtom,
} from './atoms'

export default function TravelTimeSlider() {
  const defaultValue =  TRAVEL_TIMES[2].value // 15 minutes
  const setTravelTimeLoading = useSetRecoilState(travelTimeLoadingAtom)
  const [travelTimeOptions, setTravelTimeOptions] = useRecoilState(travelTimeOptionsAtom)
  const [timer, setTimer] = React.useState(null)
  const [travelTime, setTravelTime] = React.useState(defaultValue)

  const updateTravelTime = (v) => {
    clearTimeout(timer);
    setTravelTimeLoading(true)
    setTravelTime(v)
  }

  const afterTimeout = () => {
    setTravelTimeOptions({
      ...travelTimeOptions,
      travel_time: travelTime,
    })
  }

  React.useEffect(() => {
    const t = setTimeout(afterTimeout, 1000);
    setTimer(t)
  }, [travelTime])

  return (
    <SidebarMarkSlider
      title="Travel time"
      marks={TRAVEL_TIMES}
      defaultValue={defaultValue}
      updateValue={updateTravelTime} />
  )
}
